<template>
  <HeaderView />

  <div id="main-content">
    <div class="et_pb_section ff1">
      <div>
        <img :src="img_h6" class="wp-image-a et-animated" />
      </div>
    </div>

    <div class="et_pb_section">
      <div>
        <img :src="img_h2" class="wp-image-a et-animated" />
      </div>
    </div>

    <!-- <div class="et_pb_section">
      <div>
        <img :src="img_h3" class="wp-image-a et-animated" />
      </div>
    </div> -->

    <div class="et_pb_section">
      <div>
        <img :src="img_h4" class="wp-image-a et-animated" />
      </div>
    </div>

    <div class="et_pb_section">
      <div>
        <img :src="img_h5" class="wp-image-a et-animated" />
      </div>
    </div>

    <div class="et_pb_section">
      <div>
        <img :src="img_h1" class="wp-image-a et-animated" />
      </div>
    </div>

  </div>

  <FooterView />
</template>

<script>
import HeaderView from "../components/Header.vue";
import FooterView from "../components/Footer.vue";
import img_h1 from '@/assets/images/h1.jpg';
import img_h2 from '@/assets/images/h2.jpg';
// import img_h3 from '@/assets/images/h3.jpg';
import img_h4 from '@/assets/images/h4.jpg';
import img_h5 from '@/assets/images/h5.jpg';
import img_h6 from '@/assets/images/h6.jpg';

export default {
  name: 'HomeView',
  components: {
    HeaderView,
    FooterView,
  },

  data: () => ({
    img_h1,
    img_h2,
    // img_h3,
    img_h4,
    img_h5,
    img_h6,
    images: [
      img_h2,
    ]
  }),

  methods: {
  }
}
</script>

<style>
@import '../assets/styles/home.css';
</style>
